$(document).ready(function(){

  $('.hp-featured-collections__title').click(function(){
    // Handle active class toggling
    $(this).addClass('is-active');
    $(this).siblings().removeClass('is-active');

    var dataTab = $(this).data('tab');

    // Handle tab content visibility
    $(this).parents('.hp-featured-collections').find('#'+ dataTab).addClass('is-active');
    $(this).parents('.hp-featured-collections').find('#'+ dataTab).siblings().removeClass('is-active');

    // Destroy the current Flickity instance to reinitialize it
    var $carousel = $(".hp-featured-collections__products-wrapper").flickity();
    $carousel.flickity('destroy');

    // Delay the reinitialization to give time for the layout to adjust
    flickitySliderEnable(dataTab); // Adjust the timeout duration if needed
  });

  var $slider = $(".hp-featured-collections__products-wrapper").flickity({
    wrapAround: false,
    pageDots: false,
    autoPlay: false,
    cellAlign: 'left',
    contain: true,
    groupCells: 1
  });
  
  function flickitySliderEnable(dataTab) {
    var $sliderReinitialize = $(`.hp-featured-collections__collection[id="${dataTab}"] .hp-featured-collections__products-wrapper`).flickity({
      wrapAround: false,
      pageDots: false,
      autoPlay: false,
      cellAlign: 'left',
      contain: true,
      groupCells: 1
    });

    // Ensure Flickity refreshes its layout after reinitializing
    // $slider.flickity('resize');
  }
});

